import React from "react";
import AntdBackTop from 'antd/lib/back-top';
import { withError} from '@fishx/tracker';

const BackTop = (props) => <AntdBackTop {...props} />
BackTop.displayName = 'BackTop';
export default withError(BackTop);



// WEBPACK FOOTER //
// ./src/components/back-top/index.tsx